import React from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import Loader from 'halogen/PulseLoader';
import { injectIntl, intlShape } from 'react-intl';
import { Download, Plus } from '../../helpers/icon-dictionary';
import messages from './messages';
import '../../styles/core.scss';
import css from './index.scss';
import Button from '../button/index';
import { DARK } from '../button/variants';

const ClassHeader = ({ filteredClassesCount = 0, isClassroomDataLoaded = false, isClassRollDownloaded = true,
    handleOnDownloadClassRoll, handleQuickUpload, handleAddClass, selectedProduct, intl }) => {
    const classCount = isClassroomDataLoaded
        ? <span>{filteredClassesCount}</span>
        : <Loader color="#000" margin="2px" size="6px" />;
    return (
        <div className={css.classHeaderComponent}>
            <div className={css.classesCountContainer}>
                <span className={css.classesTitle}>{selectedProduct.name}&nbsp;{intl.formatMessage(messages.classes)}
                    <span className={css.classesCount}>
                        ( {classCount} )
                    </span>
                </span>
            </div>
            <div className={css.buttonContainer}>
                <Button
                    containerClassName={css.downloadClassRoll}
                    disabled={filteredClassesCount === 0}
                    handleOnClick={handleOnDownloadClassRoll}
                    icon={Download}
                    iconClassName={css.svgIconContainer}
                    label={intl.formatMessage(messages.downloadClassRoll)}
                    loading={!isClassRollDownloaded}
                    loadingLabel={intl.formatMessage(messages.downloading)}
                    name="downloadClassRoll"
                    variant={DARK}
                    visible />
                <Button
                    containerClassName={css.bulkUpload}
                    disabled={false}
                    handleOnClick={handleQuickUpload}
                    icon={Plus}
                    iconClassName={css.svgIconContainer}
                    label={intl.formatMessage(messages.quickUpload)}
                    variant={DARK}
                    visible />
                <Button
                    containerClassName="addClassBtn"
                    disabled={!isClassroomDataLoaded}
                    handleOnClick={handleAddClass}
                    icon={Plus}
                    iconClassName={css.svgIconContainer}
                    label={intl.formatMessage(messages.addClass)}
                    variant={DARK}
                    visible />
            </div>
        </div>
    );
};

ClassHeader.propTypes = {
    isClassroomDataLoaded: PropTypes.bool,
    isClassRollDownloaded: PropTypes.bool,
    filteredClassesCount: PropTypes.number,
    handleOnDownloadClassRoll: PropTypes.func,
    handleQuickUpload: PropTypes.func,
    handleAddClass: PropTypes.func,
    selectedProduct: PropTypes.object,
    intl: intlShape.isRequired
};

export default injectIntl(styleable(css)(ClassHeader));



// WEBPACK FOOTER //
// ./app/components/class-header/index.js